export default __webpack_public_path__ + "static/media/navbar-white-list-dark.13d57579.svg";